import { Button, Form, Input, Modal, Result, Upload } from 'antd';
import { FC, useCallback, useState } from 'react';
import dicomIcon from 'assets/img/dicom.png';
import { UploadRequestOption } from 'rc-upload/lib/interface';
import { useFileUpload } from 'hooks';
import { InboxOutlined } from '@ant-design/icons';
import { createDicomShare } from 'services/api/dicomShares';
import { DicomShareRow } from 'types/api/dicomShares';

import { StyledImage, StyledResult } from './styled';
import useCopyText from 'hooks/useCopyText';
import { showErrorMessage } from 'utils/showErrorMessage';
import { Loading } from 'components/ui';

interface IProps {
  onClose: () => void;
  onSaved?: () => void;
}

const LinkPassword: FC<IProps> = ({ onClose, onSaved }) => {
  const { copyText } = useCopyText();
  const [showResult, setShowResult] = useState(false);
  const [form] = Form.useForm();
  const {
    result: file,
    upload,
    setResult
  } = useFileUpload({
    handleResult: true
  });

  const [data, setData] = useState<DicomShareRow | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (values: { name: string }) => {
      try {
        setLoading(true);
        const res = await createDicomShare({ ...values, file });
        setData(res.data);
        setShowResult(true);
        form.resetFields();
        onSaved?.();
      } catch (err) {
        showErrorMessage(err);
      } finally {
        setLoading(false);
      }
    },
    [file, form, onSaved]
  );

  const onUploadFile = async (e: UploadRequestOption) => {
    try {
      const res = await upload(e.file as File);

      e.onSuccess?.(res);
    } catch (err) {
      e.onError?.(err as ProgressEvent<EventTarget>);
    }
  };

  const result = data;

  const link = result
    ? `${result.redirect_url}?sessionId=${result.session_id}`
    : '';

  return (
    <Modal onCancel={onClose} footer={null} closable open>
      {loading ? (
        <Loading />
      ) : showResult && result ? (
        <Result
          icon={<StyledImage src={dicomIcon} />}
          style={{ padding: 0 }}
          title="Click to copy link and password"
          extra={
            <>
              <StyledResult>
                <li>
                  <b>URL: </b>{' '}
                  <span onClick={() => copyText(link)}>{link}</span>
                </li>
                {/* <li>
                  <b>Password: </b>{' '}
                  <span onClick={() => copyText(result.password)}>
                    {result.password}
                  </span>
                </li> */}
              </StyledResult>
              <br />
              <Button
                type="primary"
                style={{ width: 250 }}
                onClick={() => setShowResult(false)}
                loading={loading}
              >
                Create new
              </Button>
            </>
          }
        />
      ) : (
        <Form
          form={form}
          layout="vertical"
          size="large"
          onFinish={handleSubmit}
        >
          <Form.Item name="name" label="Title" rules={[{ required: true }]}>
            <Input maxLength={255} />
          </Form.Item>
          <Form.Item
            valuePropName="fileList"
            getValueProps={value => value}
            rules={[{ required: false }]}
          >
            <Upload.Dragger
              name="file"
              accept="application/zip"
              customRequest={onUploadFile}
              onRemove={() => setResult('')}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={form.submit} block>
              Create
            </Button>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default LinkPassword;
